import { create } from "zustand";
import { createControlSlice } from "./controlSlice";
import { createRepeatSlice } from "./repeatSlice";
import { createApplicationOneSlice } from "./applicationOneSlice";
import { createColorSchemeSlice } from "./colorSchemeSlice";

export const useBoundStore = create((...a) => ({
  ...createColorSchemeSlice(...a),
  ...createControlSlice(...a),
  ...createRepeatSlice(...a),
  ...createApplicationOneSlice(...a),
}));
